// src/hooks/useUserTracking.tsx
import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthProvider';
import { setUserId, setUserProperties } from '@/utils/analytics';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

/**
 * ユーザープロパティを自動的に設定するカスタムフック
 */
export const useUserTracking = (): void => {
  const { user } = useAuth();
  const premium = useSelector((state: RootState) => state.premium);

  useEffect(() => {
    if (user) {
      // ユーザーIDを設定
      setUserId(user.uid);

      // ユーザープロパティを設定
      setUserProperties({
        user_type: premium.temporaryPremium ? 'premium' : 'free',
        signed_in: true,
      });
    } else {
      // ログアウト時
      setUserId(null);
      setUserProperties({
        user_type: 'anonymous',
        signed_in: false,
      });
    }
  }, [user, premium.temporaryPremium]);
};
